import { render, staticRenderFns } from "./leoAddINsure.vue?vue&type=template&id=97a1f91a&scoped=true&"
import script from "./leoAddINsure.vue?vue&type=script&lang=js&"
export * from "./leoAddINsure.vue?vue&type=script&lang=js&"
import style0 from "./leoAddINsure.vue?vue&type=style&index=0&lang=less&"
import style1 from "./leoAddINsure.vue?vue&type=style&index=1&id=97a1f91a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a1f91a",
  null
  
)

export default component.exports